import React, { useEffect, useState } from "react";
import {
  GridContextProvider,
  GridDropZone,
  GridItem,
  swap,
} from "react-grid-dnd";
import axios from "axios";
import { connect } from "react-redux";
import { Col } from "react-grid-system";

import { Colors, Fonts, Images } from "../../themes";
import { StyledGrid } from "./StyledGrid";
import EditContent from "../../containers/EditContent";
import AppConfig from "../../config.js";
import Button from "../button";
import { USER_TYPE } from "../../constants";

const benefitsUrl = AppConfig.BENEFITS_URL;

function Example({ bannerData, account, type, onEditPopup }) {
  const [dataBanner, setDataBanner] = useState([]);
  const [dialogEditBanner, setDialogEditBanner] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [id, setId] = useState("");
  const [text, setText] = useState("");
  const [url, setUrl] = useState("");
  const [image, setImage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [base64Image, setBase64Image] = useState("");
  const [showButton, setShowButton] = useState(false);
  const [frequencyDisplay, setFrequencyDisplay] = useState(0);

  const fetchBanners = () => {
    axios
      .get(`${benefitsUrl}/banners`, { params: { type } })
      .then((res) => setDataBanner(res.data.payload?.data || []));
  };

  useEffect(() => {
    if (bannerData) setDataBanner(bannerData);
    fetchBanners();
  }, [bannerData]);

  const onChange = (sourceId, sourceIndex, targetIndex) => {
    const nextState = swap(dataBanner, sourceIndex, targetIndex);
    setDataBanner(nextState);
    setShowButton(true);
  };

  const onChangeText = (name, value) => {
    switch (name) {
      case "title":
        setTitle(value);
        break;
      case "description":
        setDescription(value);
        break;
      case "text":
        setText(value);
        break;
      case "url":
        setUrl(value);
        break;
      case "buttonText":
        setButtonText(value);
        break;
      case "frequencyDisplay":
        setFrequencyDisplay(value);
        break;
      default:
        break;
    }
  };

  const showItemAfterEdit = () => {
    setTimeout(fetchBanners, 500);
  };

  const onClick = () => {
    axios
      .patch(`${benefitsUrl}/banner/${id}`, {
        title,
        description,
        text,
        url,
        base64Image,
        buttonText,
        frequencyDisplay,
      })
      .then((res) => {
        if (res.data.type !== "ERROR") {
          setDialogEditBanner(false);
        }
      });
    fetchBanners();
    showItemAfterEdit();
  };

  const handleChangeI = (e) => {
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setImage(URL.createObjectURL(file));
      setBase64Image(reader.result);
    };
  };

  const showItemAfterDelete = () => {
    setTimeout(fetchBanners, 500);
  };

  const onDelete = (deleteId) => {
    if (confirm("Are you sure want to delete this banner?")) {
      axios.delete(`${benefitsUrl}/banner/${deleteId}`).then(() => {
        showItemAfterDelete();
      });
    }
  };

  const onSave = () => {
    axios
      .patch(`${benefitsUrl}/bannerOrder`, {
        dataOrder: dataBanner,
      })
      .then((res) => {
        if (res.data.type !== "ERROR") {
          setShowButton(false);
        }
      });
  };

  const onEditCard = (data) => {
    if (type === "BANNER") {
      setDialogEditBanner(true);
      setTitle(data.title);
      setId(data.id);
      setText(data.text);
      setUrl(data.url);
      setImage(data.imageUrl);
      setDescription(data.description);
      setButtonText(data.buttonText);
    } else {
      onEditPopup(data);
    }
  };

  const canEdit = account?.payload?.data?.account?.type !== USER_TYPE.VIEWER;
  const canDelete =
    account?.payload?.data?.account?.type === USER_TYPE.SUPERADMIN;

  return (
    <div>
      <EditContent
        title={title}
        id={id}
        url={url}
        text={text}
        image={image}
        description={description}
        buttonText={buttonText}
        onClick={onClick}
        onChangeImage={handleChangeI}
        onChangeText={onChangeText}
        dialogProps={{
          isVisible: dialogEditBanner,
          isClose: () => setDialogEditBanner(false),
        }}
      />

      {showButton && (
        <Col lg={3}>
          <Button
            text="Save"
            backgroundColor={Colors.color10}
            textColor="#fff"
            buttonStyle={{ marginBottom: "10px" }}
            onClick={onSave}
          />
        </Col>
      )}

      {canEdit && type === "BANNER" && (
        <p
          style={{
            color: Colors.color13,
            fontSize: Fonts.size.size14,
            fontWeight: "bold",
            paddingBottom: "20px",
          }}
        >
          *Drag and drop to reorder the positions
        </p>
      )}

      <GridContextProvider onChange={onChange}>
        <GridDropZone
          id="banner"
          boxesPerRow={3}
          rowHeight={300}
          style={{
            flex: 1,
            height: "1200px",
            borderRadius: "1rem",
          }}
          disableDrag={!canEdit}
        >
          {dataBanner.map((item, index) => (
            <GridItem key={index}>
              <StyledGrid>
                <div
                  className="card"
                  style={{
                    backgroundImage: `url(${item.imageUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
                <div className="card2">
                  <p className="title">{item.title}</p>
                  <div className="action">
                    <div className="detail-action">
                      {canEdit && (
                        <div onClick={() => onEditCard(item)}>
                          <div className="edit-wrapper">
                            <img src={Images.edit} className="edit" />
                          </div>
                        </div>
                      )}
                      {canDelete && (
                        <div onClick={() => onDelete(item.id)}>
                          <div className="trash-wrapper">
                            <img src={Images.trash} className="delete" />
                          </div>
                        </div>
                      )}
                    </div>
                    <div>
                      <div className="number-order">
                        <p className="text-order">{`No. ${index + 1}`}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </StyledGrid>
            </GridItem>
          ))}
        </GridDropZone>
      </GridContextProvider>
    </div>
  );
}

const mapStateToProps = (state) => ({
  account: state.auth.account,
});

export default connect(mapStateToProps)(Example);
